import { ShieldCheck, Atom } from "lucide-react";
import { BloqStacked } from "@/components/brand/BloqLogo";
import { WaitlistForm } from "@/components/lander/WaitlistForm";

// Variant 1 — "Signal Lock": minimal, centered, mysterious.
export default function SignalLock() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-bloq-bg text-white">
      <div className="pointer-events-none absolute inset-0 grain opacity-60" />
      <div className="pointer-events-none absolute bottom-0 right-0 h-[420px] w-[420px] rounded-full bg-bloq-purple/12 blur-[150px]" />

      <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-5 py-16 text-center">
        <div className="flex w-full max-w-xl flex-col items-center">
          <span className="mb-8 inline-flex items-center gap-2 rounded-full border border-bloq-mint/30 bg-bloq-mint/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-bloq-mint animate-fade-in" data-testid="lander-beta-pill">
            <ShieldCheck className="h-3.5 w-3.5" /> Currently in private beta testing
          </span>

          <div className="animate-fade-up">
            <BloqStacked size={265} />
          </div>

          <h1 className="mt-8 animate-fade-up text-3xl font-bold leading-tight tracking-tight sm:text-4xl" style={{ animationDelay: "120ms" }}>
            Quantum Secured Messaging
            <br className="hidden sm:block" /> for the Web3 World.
          </h1>
          <p className="mt-4 max-w-md animate-fade-up text-base text-bloq-muted" style={{ animationDelay: "200ms" }}>
            Quantum-safe keys. Encrypted at rest. Every message cryptographically signed. Trust-gated inbox, scam-blocking Shield, zero cold DMs — join the list to be first through the gate.
          </p>

          <div
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-bloq-purple/30 bg-bloq-purple/10 px-4 py-1.5 text-xs font-semibold text-bloq-purple animate-fade-up"
            style={{ animationDelay: "240ms" }}
            data-testid="quantum-only-badge"
          >
            <Atom className="h-3.5 w-3.5" /> The only messenger that's quantum-secured
          </div>

          <div id="waitlist" className="mt-9 w-full max-w-md animate-fade-up scroll-mt-24" style={{ animationDelay: "280ms" }}>
            <WaitlistForm founding stacked />
          </div>

          <p className="mt-10 text-sm text-bloq-muted">Secure conversations. Verified communities. Safer Web3.</p>
        </div>
      </div>
    </div>
  );
}
